import { render, staticRenderFns } from "./Jan14.vue?vue&type=template&id=fabca2e2&scoped=true&"
import script from "./Jan14.vue?vue&type=script&lang=js&"
export * from "./Jan14.vue?vue&type=script&lang=js&"
import style0 from "./Jan14.vue?vue&type=style&index=0&id=fabca2e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabca2e2",
  null
  
)

export default component.exports